/* eslint-disable no-unused-vars */
import { IconButton, Tooltip } from '@material-ui/core';
import { ClearAll, Flip } from '@material-ui/icons';
import React, { useState, useEffect } from 'react';
import { ButtonWrapper, ContentWrapper, InnerContent, OuterContent, Wrapper, } from './SideBarComponent.Styles';
export var SideBarComponent = function (_a) {
    var children = _a.children, open = _a.open, readonly = _a.readonly, component = _a.component, topOffSet = _a.topOffSet, onClose = _a.onClose;
    var _b = useState('medium'), sSize = _b[0], setSize = _b[1];
    var _c = useState(false), sFloat = _c[0], setFloat = _c[1];
    useEffect(function () {
        if (!open) {
            onClose && onClose();
        }
    }, [open]);
    var handleSize = function () {
        setSize(sSize === 'medium' ? 'large' : 'medium');
    };
    var handleFloat = function () {
        setFloat(!sFloat);
    };
    return (React.createElement(Wrapper, { topOffSet: topOffSet },
        React.createElement(OuterContent, null, children),
        React.createElement(InnerContent, { open: open, size: sSize, floating: sFloat },
            React.createElement(ContentWrapper, { disable: !!readonly }, component),
            React.createElement(ButtonWrapper, { disable: !open },
                React.createElement(Tooltip, { title: sSize === 'medium' ? 'Expand' : 'Contract' },
                    React.createElement(IconButton, { size: 'small', onClick: handleSize },
                        React.createElement(ClearAll, null))),
                React.createElement(Tooltip, { title: sFloat === true ? 'Relative' : 'Fixed' },
                    React.createElement(IconButton, { size: 'small', onClick: handleFloat },
                        React.createElement(Flip, null)))))));
};
SideBarComponent.defaultProps = {
    open: false
};
//# sourceMappingURL=SideBarComponent.js.map